import {Component, EventEmitter, OnInit, Output, ViewChild, inject} from '@angular/core';
import {ClsConfig} from '../../../../../util/cls-config';
import {AppPresupuestosService} from '../../../../../core/services/app-presupuestos.service';
import {ClsArbolPartida} from '../../../../../core/models/cls-partida';
import {
  FilteringLogic,
  IgxStringFilteringOperand
} from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {FiltroGeneralComponent} from '../../filtro-general/filtro-general.component';
import {TranslateModule} from '@ngx-translate/core';
import {SummaryPipeNeoPipe} from "../../../../../core/pipes/summary-pipe-neo.pipe";
import {ClsObjGenerico} from "../../../../../clases-pu/util/cls-obj-generico";
import {TipoMensajesService} from "../../../../../core/services/tipo-mensajes.service";
import {EnumMasOpciones} from "../../../../../core/models/enum/enum-mas-opciones";
import {ClsUtil} from "../../../../../util/cls-util";
import {MasOpcionesGridComponent} from "../../mas-opciones-grid/mas-opciones-grid.component";
import {IgxExcelExporterService} from "@infragistics/igniteui-angular/grids/core";

@Component({
  selector: 'app-grid-partidas',
  templateUrl: './grid-partidas.component.html',
  styleUrls: ['./grid-partidas.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    IgxIconComponent,
    FiltroGeneralComponent,
    TranslateModule,
    SummaryPipeNeoPipe,
    MasOpcionesGridComponent
  ]
})
export class GridPartidasComponent extends ClsConfig implements OnInit {
  private infPpto = inject(AppPresupuestosService);
  private tipoMsg = inject(TipoMensajesService);

  private excelExportService = inject(IgxExcelExporterService);

  @ViewChild('gridPartidas', {read: IgxGridComponent, static: true})
  public gridPartidas: IgxGridComponent;

  @ViewChild('filtroGeneral', {read: FiltroGeneralComponent, static: true})
  public filtroGeneral: FiltroGeneralComponent;

  @Output()
  public partidaSeleccionada: EventEmitter<ClsArbolPartida> = new EventEmitter<ClsArbolPartida>();

  public mostrarUltimoNivel = false;

  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();

  public partidas: ClsArbolPartida[] = [];
  public errorAlCargar: boolean;
  public activarBotones = false;

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

  public cargarPartidas() {
    try {
      const dataPartidas: ClsArbolPartida[] = this.infPpto.dmPrincipal.dmSecundarioPptoActivo.Ppto.partidaComponent.treeGridPartidas.flatData;
      if (this.mostrarUltimoNivel) {
        const partidasConConceptos = new Set(
          this.infPpto.pptoActivoCompletoJSON.Presupuesto.map(p => p.IdPresupuestoPartida)
        );
        this.partidas = dataPartidas.filter(p => partidasConConceptos.has(p.IdPresupuestoPartida));
      } else {
        this.partidas = dataPartidas;
      }
    } catch (e) {
      this.errorAlCargar = true;
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridPartidas, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.PARTIDAS'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridPartidas.selectedRows.length));
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridPartidas.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridPartidas.filteringLogic = FilteringLogic.Or;
    this.gridPartidas.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridPartidas.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridPartidas.getRowData(rowSeleccionados[0]);
      this.gridPartidas.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
